export class Login  {
    public strUsuario?: string; 
    public strContrasena?: string; 
    public intRolTipo?: number; 
    public strCookie?: string; 
}